import { ApiHiringFlowField, HiringFlowEditorSection } from "@/types/hiring-flow.types";
import { Draggable, Droppable } from "@hello-pangea/dnd";
import { DropdownMenuItem, FontAwesomeIcon, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { HiringFlowFieldRow } from "@/pages/settings/hiring-flows/edit/components/HiringFlowFieldRow";
import { HiringFlowRowMenu } from "@/pages/settings/hiring-flows/edit/components/HiringFlowRowMenu";

export function HiringFlowSection({
  section,
  index,
  title,
  disabled,
  onEdit,
  onDelete,
  onFieldChange,
}: {
  section: HiringFlowEditorSection;
  index: number;
  title: string;
  disabled: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onFieldChange: (slug: string, changes: Partial<ApiHiringFlowField>) => void;
}) {
  const { t } = useTranslation();

  return (
    <Draggable draggableId={section.key} index={index} isDragDisabled={disabled}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <Stack
            {...provided.dragHandleProps}
            direction="horizontal"
            items="center"
            justify={"between"}
            gap="md"
            className={twMerge(
              "group min-h-14 border-b border-dark/10 pl-14 py-3 gap-(--gap-md) bg-light",
              !disabled && "cursor-grab"
            )}
          >
            <Title header={title} size="xs" />
            <div className="grow" />
            {!disabled && (
              <HiringFlowRowMenu>
                <DropdownMenuItem title={t("hiring_flow:rename_section")} onClick={onEdit} />
                {section.fields.length === 0 && (
                  <DropdownMenuItem title={t("hiring_flow:delete_section")} onClick={onDelete} />
                )}
              </HiringFlowRowMenu>
            )}
            <div className="w-10 flex justify-center items-center">
              <FontAwesomeIcon icon="fa-light fa-grip-dots-vertical" />
            </div>
          </Stack>

          <Droppable droppableId={section.key} type="field" isDropDisabled={disabled}>
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps} className="min-h-4">
                {section.fields.map((field, fieldIndex) => (
                  <HiringFlowFieldRow
                    key={field.field.slug}
                    field={field}
                    index={fieldIndex}
                    disabled={disabled}
                    onChange={(changes) => onFieldChange(field.field.slug, changes)}
                  />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      )}
    </Draggable>
  );
}
